import axios from "axios";
import config from "../lib/Config";

class ActivationApi {
	base_api = config.base_api;
	token = config.token;

	getProjectActivation(params) {
		return axios.get(this.base_api + `project_activations/`, {
			params: params,
			headers: {
				Authorization: "Token " + this.token,
				"Content-Type": "application/json",
			},
		});
	}

    changeProjectStatus(projectId, data) {
		return axios.patch(this.base_api + `projects/${projectId}/`, data, {
			params: {},
			headers: {
				Authorization: "Token " + this.token,
				"Content-Type": "application/json",
			},
		});
	}
}

export default ActivationApi;
